import ServiceExec from '@/common/utils/ServiceExec';
import { admin_customerAPI } from '@/common/service/ApiList';
import router from '@/router';
import { asFormData } from '@/common/utils/ServiceSupport';

export default {
  // 상점관리자 - 고객관리 리스트
  async customerList({ commit, state }, payload) {
    const { page, totalPage, limit } = state;
    if (page > totalPage) return;

    const { data, status } = await ServiceExec.get(
      admin_customerAPI.customer_list,
      { page, limit, ...payload }
    );

    const { pageInfo, list } = data;

    commit('setPage', page + 1);
    commit('setTotalPage', pageInfo?.totalPage ?? 2);
    commit('setList', list ?? []);
  },

  async customerSearchList({ commit, state }, payload) {
    const { page, totalPage, limit } = state;
    if (page > 1) {
      commit('setPageInit');
      commit('setListInit');
      const { page, totalPage, limit } = state;
      const { data, status } = await ServiceExec.get(
        admin_customerAPI.customer_list,
        { page, limit, ...payload }
      );

      const { pageInfo, list } = data;
      commit('setPage', page + 1);
      commit('setTotalPage', pageInfo?.totalPage ?? 2);
      commit('setList', list ?? []);
    } else {
      const { page, totalPage, limit } = state;
      const { data, status } = await ServiceExec.get(
        admin_customerAPI.customer_list,
        { page, limit, ...payload }
      );

      const { pageInfo, list } = data;

      commit('setPage', page + 1);
      commit('setTotalPage', pageInfo?.totalPage ?? 2);
      commit('setList', list ?? []);
    }
  },

  async detail({ commit }, payload) {
    const { data, status } = await ServiceExec.get(
      admin_customerAPI.customer_detail(payload.storeNo, payload.userNo)
    );

    if (status === 200) commit('setDetail', data);
  },

  // 상점관리자 - 쿠폰 저장
  async save({ commit, state }, payload) {
    const { data, status } = await ServiceExec.post(
      admin_customerAPI.coupon_save,
      asFormData(payload)
    );
    if (status === 200) await router.push('/admin/manage/issue/list');
  },

  async updateBlockState({ commit }, payload) {
    const { data, status } = await ServiceExec.post(
      admin_customerAPI.customer_save,
      payload
    );

    return data;
  }
};
